'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _classnames6 = require('classnames');

var _classnames7 = _interopRequireDefault(_classnames6);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetPopupSettings = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AssetPopupSettings, _React$Component);

  function AssetPopupSettings(props) {
    (0, _classCallCheck3.default)(this, AssetPopupSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AssetPopupSettings.__proto__ || (0, _getPrototypeOf2.default)(AssetPopupSettings)).call(this, props));

    _this.state = {
      masterToggleValue: false,
      masterToggleClicked: false,
      masterMimeTypeValue: 'image/jpeg',
      master: false,
      loaded: false
    };
    return _this;
  }

  (0, _createClass3.default)(AssetPopupSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          asset = _props.asset,
          subscription = _props.subscription,
          onSettingsChange = _props.onSettingsChange,
          onComponentsChange = _props.onComponentsChange;
      var acl = asset.acl,
          points = asset.points,
          brushes = asset.brushes,
          meshes = asset.meshes,
          models = asset.models,
          maps = asset.maps;


      var subscriptionAccess = subscription && subscription.accessResolution;
      var aclAccess = acl && acl.resolution;
      var access = subscriptionAccess || aclAccess;
      var canUserAccessResolution = function canUserAccessResolution(r) {
        return points === 0 || !((0, _utils.parseResolution)(r)[0] > access);
      };

      var subscriptionExrAccess = subscription && subscription.exrAccess;
      var aclExrAccess = acl && acl.exrAccess;
      var exrAccess = subscriptionExrAccess || aclExrAccess;

      this.setState({ loaded: true });

      var type = (0, _utils.getAssetType)(asset) === '3d' ? '3d' : (0, _utils.getAssetType)(asset) === '3dplant' ? '3dplant' : '2d';
      var resolutions = type !== '3dplant' ? (0, _utils.getAssetResolutions)(this.props.asset) : _underscore2.default.uniq(_underscore2.default.pluck(maps, 'resolution'));
      var lods = type !== '3dplant' ? _underscore2.default.compact(_underscore2.default.pluck(meshes, 'tris')) : ['all'].concat(_underscore2.default.uniq(_underscore2.default.pluck(models, 'lod'))).concat(['billboards']);

      var settingsMeta = require('data/asset/settings/' + type + '.json');
      var settingsRules = require('data/asset/settings/rules.json');

      var recoveredState = this.recoverState();

      var resolveLod = function resolveLod(lod, def) {
        return lods.find(function (l) {
          return l == lod;
        }) || def;
      };

      var resolveResolution = function resolveResolution(resolution, def) {
        return resolutions.find(function (r) {
          return r == resolution && canUserAccessResolution(r);
        }) || resolutions.find(canUserAccessResolution) || def;
      };

      var settings = _underscore2.default.mapObject(_underscore2.default.extendOwn(_underscore2.default.mapObject(settingsMeta, function (v) {
        return v.type == 'lod' ? lods[v.defaultIndex] : v.default;
      }), { resolution: resolutions[0] }), function (v, k) {
        if (recoveredState && recoveredState.settings && recoveredState.settings[k]) {
          if (k == 'maxlod') {
            return resolveLod(recoveredState.settings[k], v);
          } else if (k == 'resolution') {
            return resolveResolution(recoveredState.settings[k], v);
          } else {
            return recoveredState.settings[k];
          }
        } else {
          return v;
        }
      });

      var components = this.computeComponents(asset.components || [], settings, settingsRules, true).map(function (c) {
        if (!recoveredState.components) return c;

        var recoveredComponent = recoveredState.components.find(function (comp) {
          return c.type == comp.type;
        });

        return (0, _extends3.default)({}, c, {
          mimeType: exrAccess != 'full' ? 'image/jpeg' : recoveredComponent ? recoveredComponent.mimeType : c.mimeType,
          selected: !recoveredComponent || recoveredComponent.selected
        });
      });

      this.setState({ settingsMeta: settingsMeta, settingsRules: settingsRules });

      onSettingsChange(settings);
      if (asset.categories[0] !== '3dplant') onComponentsChange(components);
    }
  }, {
    key: 'persistState',
    value: function persistState(_ref) {
      var settings = _ref.settings,
          components = _ref.components;

      if (settings) {
        var oldSettings = void 0;
        var newSettings = settings;

        try {
          oldSettings = JSON.parse(window.localStorage.getItem('settings'));
        } catch (e) {}

        if (oldSettings) {
          newSettings = _underscore2.default.extendOwn(oldSettings, newSettings);
        }

        window.localStorage.setItem('settings', (0, _stringify2.default)(newSettings));
      }

      if (components) {
        var oldComponents = void 0;
        var newComponents = components;

        try {
          oldComponents = JSON.parse(window.localStorage.getItem('components'));
        } catch (e) {}

        if (oldComponents) {}

        window.localStorage.setItem('components', (0, _stringify2.default)(newComponents));
      }
    }
  }, {
    key: 'recoverState',
    value: function recoverState() {
      var settings = {};
      var components = {};

      try {
        settings = JSON.parse(window.localStorage.getItem('settings'));
      } catch (e) {}

      try {
        components = JSON.parse(window.localStorage.getItem('components'));
      } catch (e) {}

      return { settings: settings, components: components };
    }
  }, {
    key: 'computeComponents',
    value: function computeComponents(components, settings, rules) {
      var initial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var isComponentMissing = function isComponentMissing(component) {
        return !components.find(function (c) {
          return c.type == component;
        });
      };
      var asset = this.props.asset;


      return components.map(function (c) {
        var rule = rules.find(function (r) {
          return r.component == c.type;
        });
        var component = asset.components.find(function (comp) {
          return comp.type == c.type;
        });

        if (!component) {
          return c;
        }

        var included = !rule || rule.rules.some(function (r) {
          var matching = settings[r.key] == r.value;

          if (r.whenMissing) {
            matching = isComponentMissing(r.whenMissing);
          }

          return matching;
        });

        var mimeTypes = (0, _utils.getComponentMimetypes)(component);
        var mimeType = c.mimeType || mimeTypes.find(function (m) {
          return m == 'image/jpeg';
        }) || mimeTypes[0];

        return {
          type: c.type,
          mimeType: mimeType,
          selected: initial || c.selected,
          included: included
        };
      });
    }
  }, {
    key: 'handlePlantResolutionChanged',
    value: function handlePlantResolutionChanged(ev) {
      if (!this.state.loaded) return;

      var _props2 = this.props,
          settings = _props2.settings,
          onSettingsChange = _props2.onSettingsChange;

      var el = ev.currentTarget;

      var nextSettings = (0, _extends3.default)({}, settings, {
        resolution: el.value
      });

      this.persistState({ settings: nextSettings });
      onSettingsChange(nextSettings);
    }
  }, {
    key: 'handlePlantLODChanged',
    value: function handlePlantLODChanged(ev) {
      if (!this.state.loaded) return;

      var _props3 = this.props,
          settings = _props3.settings,
          onSettingsChange = _props3.onSettingsChange;

      var el = ev.currentTarget;

      var nextSettings = (0, _extends3.default)({}, settings, {
        plantlod: el.value
      });

      this.persistState({ settings: nextSettings });
      onSettingsChange(nextSettings);
    }
  }, {
    key: 'handlePlantMimetypeChanged',
    value: function handlePlantMimetypeChanged(ev) {
      var _props4 = this.props,
          components = _props4.components,
          onComponentsChange = _props4.onComponentsChange;

      var el = ev.currentTarget;

      var nextComponents = (0, _extends3.default)({}, components, {
        mimeType: el.value
      });

      onComponentsChange(nextComponents);
    }
  }, {
    key: 'handleSettingChanged',
    value: function handleSettingChanged(ev) {
      var _props5 = this.props,
          components = _props5.components,
          asset = _props5.asset,
          settings = _props5.settings,
          onSettingsChange = _props5.onSettingsChange,
          onComponentsChange = _props5.onComponentsChange;
      var settingsRules = this.state.settingsRules;
      var meshes = asset.meshes;

      var lods = _underscore2.default.compact(_underscore2.default.pluck(meshes, 'tris'));
      var el = ev.currentTarget;

      var nextSettings = _underscore2.default.mapObject(settings, function (s, k) {
        if (k == el.name) {
          return el.type == 'checkbox' ? el.checked : el.value.match(/^\d+$/) ? parseInt(el.value) : el.value;
        } else if (k == 'highpoly' && el.name == 'maxlod' && el.value == '0') {
          return true;
        } else if (k == 'maxlod' && s == '0' && el.name == 'highpoly' && !el.checked) {
          return parseInt(lods[0]);
        } else {
          return s;
        }
      });

      var nextComponents = this.computeComponents(components, nextSettings, settingsRules);

      this.persistState({ components: nextComponents, settings: nextSettings });

      onSettingsChange(nextSettings);
      onComponentsChange(nextComponents);
    }
  }, {
    key: 'handleComponentSwitched',
    value: function handleComponentSwitched(ev) {
      this.setState({ master: false, masterToggleClicked: false });

      var _props6 = this.props,
          components = _props6.components,
          onComponentsChange = _props6.onComponentsChange;

      var el = ev.currentTarget;

      var nextComponents = components.map(function (c) {
        return (0, _extends3.default)({}, c, {
          selected: el.name == c.type ? !!el.checked : c.selected
        });
      });

      this.persistState({ components: nextComponents });

      onComponentsChange(nextComponents);
    }
  }, {
    key: 'handleComponentMimetypeChanged',
    value: function handleComponentMimetypeChanged(ev) {
      this.setState({ master: false, masterToggleClicked: false });

      var _props7 = this.props,
          onComponentsChange = _props7.onComponentsChange,
          components = _props7.components;

      var el = ev.currentTarget;

      var nextComponents = components.map(function (c) {
        return c.type != el.name ? c : (0, _extends3.default)({}, c, { mimeType: el.value });
      });

      this.persistState({ components: nextComponents });

      onComponentsChange(nextComponents);
    }
  }, {
    key: 'handleTagClick',
    value: function handleTagClick(ev, tag) {
      ev.preventDefault();

      var doSearch = this.context.doSearch;


      doSearch([tag]);
    }
  }, {
    key: 'onLoginClick',
    value: function onLoginClick(ev) {
      var _context = this.context,
          router = _context.router,
          location = _context.location;


      router.push((0, _extends3.default)({}, location, { query: (0, _extends3.default)({}, location.query, { login: true }) }));
    }
  }, {
    key: 'render',
    value: function render() {
      var asset = this.props.asset;

      var is3dPlant = asset.categories[0] === '3dplant';
      var assetName = is3dPlant ? asset.name : (0, _utils.getAssetName)(asset);

      var styles = require('./AssetPopupSettings.scss');

      var renderThumbVertical = function renderThumbVertical() {
        return _react2.default.createElement('div', { style: {
            background: '#000',
            borderRadius: '4px',
            width: '8px',
            display: 'block',
            border: '1px solid #c6c6c6'
          } });
      };

      return _react2.default.createElement(
        'div',
        { className: styles.AssetPopupSettings },
        _react2.default.createElement(
          'div',
          { className: styles['AssetPopupSettings__section-container'] },
          _react2.default.createElement(
            _reactCustomScrollbars.Scrollbars,
            { universal: true, autoHeight: true, autoHide: true, renderThumbVertical: renderThumbVertical },
            _react2.default.createElement(
              'div',
              { className: styles['AssetPopupSettings__section-guts'] },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h1',
                  { className: styles.AssetPopupSettings__title, title: assetName },
                  assetName
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.AssetPopupSettings__section },
                this.renderTags()
              ),
              !is3dPlant && _react2.default.createElement(
                'div',
                { className: styles.AssetPopupSettings__section },
                this.renderAdvancedSettings()
              ),
              !is3dPlant && _react2.default.createElement(
                'div',
                { className: styles.AssetPopupSettings__section },
                this.renderAdvancedSettings(true)
              ),
              !is3dPlant && _react2.default.createElement(
                'div',
                { className: styles.AssetPopupSettings__section },
                this.renderComponents()
              ),
              is3dPlant && _react2.default.createElement(
                'div',
                { className: styles.AssetPopupSettings__section },
                this.renderPlantSettings()
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles['AssetPopupSettings__footer'] },
          this.renderFooter()
        )
      );
    }
  }, {
    key: 'renderPlantSettings',
    value: function renderPlantSettings() {
      var _classnames;

      var styles = require('./AssetPopupSettings.scss');

      var settingsMeta = this.state.settingsMeta;
      var _props8 = this.props,
          asset = _props8.asset,
          subscription = _props8.subscription,
          settings = _props8.settings,
          components = _props8.components;
      var acl = asset.acl,
          points = asset.points,
          brushes = asset.brushes,
          meshes = asset.meshes,
          models = asset.models,
          maps = asset.maps,
          billboards = asset.billboards;


      var subscriptionAccess = subscription && subscription.accessResolution;
      var aclAccess = acl && acl.resolution;
      var access = aclAccess || subscriptionAccess;

      var subscriptionExrAccess = subscription && subscription.exrAccess;
      var aclExrAccess = acl && acl.exrAccess;
      var showExr = aclExrAccess == 'full' || subscriptionExrAccess == 'full';
      var canUserAccessResolution = function canUserAccessResolution(r) {
        return points === 0 || !((0, _utils.parseResolution)(r)[0] > access);
      };
      var shouldIncludeResolution = function shouldIncludeResolution(r) {
        return !access || canUserAccessResolution(r);
      };

      var classes = (0, _classnames7.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.AssetPopupSettings__component, true), (0, _defineProperty3.default)(_classnames, styles['AssetPopupSettings__component--included'], true), _classnames));

      var mapTypes = _underscore2.default.uniq(_underscore2.default.union(_underscore2.default.pluck(billboards, 'name'), _underscore2.default.pluck(maps, 'name')));

      return _react2.default.createElement(
        'div',
        null,
        !!asset.description && _react2.default.createElement(
          'div',
          { className: styles.AssetPopupSettings__description },
          asset.description
        ),
        _react2.default.createElement(
          'div',
          { className: styles.AssetPopupSettings__field },
          _react2.default.createElement(
            'label',
            { htmlFor: "asset-settings-resolution" },
            'Resolution:\xA0'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              className: styles['AssetPopupSettings__field-select'],
              name: 'resolution',
              id: "asset-settings-resolution",
              value: settings['resolution'],
              onChange: this.handlePlantResolutionChanged.bind(this) },
            _underscore2.default.uniq(_underscore2.default.pluck(maps, 'resolution')).filter(shouldIncludeResolution).map(function (res) {
              return _react2.default.createElement(
                'option',
                { value: res, key: res },
                (0, _utils.getResolutionShortform)(res)
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.AssetPopupSettings__field },
          _react2.default.createElement(
            'label',
            { htmlFor: "asset-settings-maxlod" },
            'Level of detail:\xA0'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              className: styles['AssetPopupSettings__field-select'],
              name: 'plantlod',
              id: "asset-settings-plantlod",
              value: settings['plantlod'] + '',
              onChange: this.handlePlantLODChanged.bind(this) },
            _react2.default.createElement(
              'option',
              { value: 'all', key: 'all' },
              'All LODs'
            ),
            _underscore2.default.uniq(_underscore2.default.pluck(models, 'lod')).map(function (t, i, a) {
              return i !== a.length - 1 ? _react2.default.createElement(
                'option',
                { value: t, key: t },
                'LOD ' + t
              ) : _react2.default.createElement(
                'option',
                { value: 'billboard', key: 'billboard' },
                'Billboard'
              );
            })
          )
        ),
        showExr && _react2.default.createElement(
          'div',
          { className: styles.AssetPopupSettings__field },
          _react2.default.createElement(
            'label',
            { htmlFor: "asset-settings-maxlod" },
            'Format:\xA0'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              name: 'mimeType',
              value: components && components['mimeType'] || 'image/x-exr',
              className: styles['AssetPopupSettings__field-select'],
              onChange: this.handlePlantMimetypeChanged.bind(this) },
            _underscore2.default.uniq(_underscore2.default.pluck(maps, 'mimeType')).map(function (mimeType) {
              return _react2.default.createElement(
                'option',
                {
                  id: mimeType,
                  key: Math.random() + '-' + mimeType,
                  value: mimeType },
                (0, _utils.getFileTypeFromMimeType)(mimeType).toUpperCase()
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { fontSize: '1em', textAlign: 'left', clear: 'both', lineHeight: '1.3em', padding: '2em 0 1em' } },
          'Asset contains following maps:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          mapTypes.map(function (m) {
            return _react2.default.createElement(
              'li',
              { className: classes },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                  'span',
                  { className: styles['AssetPopupSettings__component-name'] },
                  '- ' + m
                )
              )
            );
          })
        )
      );
    }
  }, {
    key: 'renderTags',
    value: function renderTags() {
      var _this2 = this;

      var tags = this.props.asset.tags;

      var styles = require('./AssetPopupSettings.scss');

      return _react2.default.createElement(
        'ul',
        { className: styles['AssetPopupSettings__tags'] },
        tags.map(function (tag) {
          return _react2.default.createElement(
            'li',
            { className: styles['AssetPopupSettings__tag'], key: tag },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/megascans?query=' + tag, onClick: _underscore2.default.partial(_this2.handleTagClick.bind(_this2), _underscore2.default, tag) },
              tag
            )
          );
        }),
        _react2.default.createElement(
          'li',
          {
            key: 'add-new-tag',
            className: styles['AssetPopupSettings__tag'] + ' ' + styles['AssetPopupSettings__tag-add'],
            onClick: function onClick() {
              return _this2.context.dialogs.custom(_react2.default.createElement(_components.SuggestTagDialog, { asset: _this2.props.asset.id }));
            }
          },
          '+Add Tag'
        )
      );
    }
  }, {
    key: 'renderAdvancedSettings',
    value: function renderAdvancedSettings() {
      var _this3 = this;

      var renderCheckboxes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.state || !this.state.settingsMeta) return;

      var styles = require('./AssetPopupSettings.scss');

      var settingsMeta = this.state.settingsMeta;
      var _props9 = this.props,
          asset = _props9.asset,
          subscription = _props9.subscription,
          settings = _props9.settings;
      var acl = asset.acl,
          points = asset.points,
          brushes = asset.brushes,
          meshes = asset.meshes;


      var subscriptionAccess = subscription && subscription.accessResolution;
      var aclAccess = acl && acl.resolution;
      var access = aclAccess || subscriptionAccess;
      var canUserAccessResolution = function canUserAccessResolution(r) {
        return points === 0 || !((0, _utils.parseResolution)(r)[0] > access);
      };
      var shouldIncludeResolution = function shouldIncludeResolution(r) {
        return !access || canUserAccessResolution(r);
      };

      return _react2.default.createElement(
        'div',
        null,
        !renderCheckboxes && _react2.default.createElement(
          'div',
          { className: styles.AssetPopupSettings__field },
          _react2.default.createElement(
            'label',
            { htmlFor: "asset-settings-resolution" },
            'Resolution:\xA0'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              className: styles['AssetPopupSettings__field-select'],
              name: 'resolution',
              id: "asset-settings-resolution",
              value: settings['resolution'],
              onChange: this.handleSettingChanged.bind(this) },
            (0, _utils.getAssetResolutions)(this.props.asset).filter(shouldIncludeResolution).map(function (res) {
              return _react2.default.createElement(
                'option',
                { value: res, key: res },
                (0, _utils.getResolutionShortform)(res)
              );
            })
          )
        ),
        _underscore2.default.values(_underscore2.default.mapObject(settingsMeta, function (setting, key) {
          var _classnames2;

          var value = settings[key];
          value = _underscore2.default.isNumber(value) ? value.toString() : value;

          if (key == 'brushes' && (!brushes || !brushes.length)) {
            return;
          }

          // Disable ZTL toggle when .ztl file is not available
          if (setting.name.toLowerCase() === 'Source ZTool'.toLowerCase()) {
            if (key == 'ztool' && _underscore2.default.pluck(meshes, 'type').indexOf('zbrush') < 0) {
              return;
            }
          }

          // Render only checkboxes
          if (renderCheckboxes && setting.type !== 'checkbox') return null;

          // Default case, Ignore rendering Checkboxes
          if (!renderCheckboxes && setting.type === 'checkbox') return null;

          return _react2.default.createElement(
            'div',
            { key: key, className: (0, _classnames7.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles.AssetPopupSettings__field, true), (0, _defineProperty3.default)(_classnames2, styles['AssetPopupSettings__field-halfWidth'], renderCheckboxes), (0, _defineProperty3.default)(_classnames2, styles['AssetPopupSettings__field--disabled'], setting.type === 'checkbox' && !value), _classnames2)) },
            setting.type !== 'checkbox' && _react2.default.createElement(
              'label',
              { htmlFor: "asset-settings-" + key },
              setting.name,
              ':\xA0'
            ),
            setting.type === 'select' && _react2.default.createElement(
              _components.Select,
              {
                className: styles['AssetPopupSettings__field-select'],
                name: key,
                id: "asset-settings-" + key,
                value: value,
                onChange: _this3.handleSettingChanged.bind(_this3) },
              setting.options.map(function (option) {
                return _react2.default.createElement(
                  'option',
                  { key: option.key, value: option.key },
                  option.name
                );
              })
            ),
            setting.type === 'displacement' && _react2.default.createElement(
              _components.Select,
              {
                className: styles['AssetPopupSettings__field-select'],
                name: key,
                id: "asset-settings-" + key,
                value: value,
                onChange: _this3.handleSettingChanged.bind(_this3) },
              components.find(function (c) {
                return c.type === 'displacement';
              }).uris[0].resolutions[0].formats.map(function (t) {
                return _react2.default.createElement(
                  'option',
                  { key: t.bitDepth, value: t.bitDepth },
                  t.bitDepth + ' bit (' + (0, _utils.getFileTypeFromMimeType)(t.mimeType).toUpperCase() + ')'
                );
              })
            ),
            setting.type === 'lod' && _react2.default.createElement(
              _components.Select,
              {
                className: styles['AssetPopupSettings__field-select'],
                name: key,
                id: "asset-settings-" + key,
                value: value,
                onChange: _this3.handleSettingChanged.bind(_this3) },
              _react2.default.createElement(
                'option',
                { value: '0' },
                'No LOD'
              ),
              _underscore2.default.compact(_underscore2.default.pluck(meshes, 'tris')).map(function (t) {
                return _react2.default.createElement(
                  'option',
                  { value: t, key: t },
                  (0, _utils.numberWithCommas)(t) + ' Tris'
                );
              })
            ),
            setting.type == 'checkbox' && _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_components.Checkbox, {
                checked: !!value,
                name: key,
                id: "asset-settings-" + key,
                onChange: _this3.handleSettingChanged.bind(_this3),
                className: styles['AssetPopupSettings__field-checkbox'] }),
              setting.name
            )
          );
        }))
      );
    }
  }, {
    key: 'handleMasterSwitch',
    value: function handleMasterSwitch(e) {
      if (!this.state.loaded) return;
      this.setState({ master: true, masterToggleClicked: true, masterToggleValue: e.currentTarget.checked });

      var _props10 = this.props,
          components = _props10.components,
          onComponentsChange = _props10.onComponentsChange;

      var el = e.currentTarget;

      var nextComponents = components.map(function (c) {
        return (0, _extends3.default)({}, c, {
          selected: !!el.checked
        });
      });

      this.persistState({ components: nextComponents });

      onComponentsChange(nextComponents);
    }
  }, {
    key: 'handleMasterDropdown',
    value: function handleMasterDropdown(e) {
      if (!this.state.loaded) return;
      this.setState({ master: true, masterToggleClicked: false, masterMimeTypeValue: e.currentTarget.value });

      var _props11 = this.props,
          onComponentsChange = _props11.onComponentsChange,
          components = _props11.components;

      var el = e.currentTarget;

      var nextComponents = components.map(function (c) {
        return (0, _extends3.default)({}, c, {
          mimeType: el.value
        });
      });

      this.persistState({ components: nextComponents });

      onComponentsChange(nextComponents);
    }

    // UFK - 2016/08/01
    // Enable master switch for settings

  }, {
    key: 'renderMasterSwitch',
    value: function renderMasterSwitch(showExr) {
      var _classnames3;

      var styles = require('./AssetPopupSettings.scss');
      return _react2.default.createElement(
        'li',
        { className: (0, _classnames7.default)((_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, styles.AssetPopupSettings__component, true), (0, _defineProperty3.default)(_classnames3, styles['AssetPopupSettings__component-noExr'], !showExr), (0, _defineProperty3.default)(_classnames3, styles['AssetPopupSettings__component--included'], this.state.master), _classnames3)) },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement('span', { className: styles['AssetPopupSettings__component-average-color'], style: { background: 'transparent' } }),
          _react2.default.createElement(
            'span',
            { className: styles['AssetPopupSettings__component-name'] },
            'Toggle All'
          ),
          _react2.default.createElement(_components.Checkbox, {
            className: styles['AssetPopupSettings__component-include'],
            name: 'master-toggle',
            checked: this.state.masterToggleValue,
            onChange: this.handleMasterSwitch.bind(this) })
        ),
        showExr && _react2.default.createElement(
          'span',
          { className: styles['AssetPopupSettings__component-mimeType'] },
          _react2.default.createElement(
            _components.Select,
            {
              name: 'master-dropdown',
              value: this.state.masterMimeTypeValue,
              className: styles['AssetPopupSettings__component-mimeTypeSelect'],
              onChange: this.handleMasterDropdown.bind(this) },
            _react2.default.createElement(
              'option',
              { id: 'image/jpeg', key: 'image/jpeg', value: 'image/jpeg' },
              'JPG'
            ),
            _react2.default.createElement(
              'option',
              { id: 'image/x-exr', key: 'image/x-exr', value: 'image/x-exr' },
              'EXR'
            )
          )
        )
      );
    }
  }, {
    key: 'renderComponents',
    value: function renderComponents() {
      var _this4 = this;

      var _props12 = this.props,
          asset = _props12.asset,
          components = _props12.components,
          subscription = _props12.subscription;
      var _state = this.state,
          master = _state.master,
          masterToggleValue = _state.masterToggleValue,
          masterToggleClicked = _state.masterToggleClicked,
          masterMimeTypeValue = _state.masterMimeTypeValue;
      var acl = asset.acl;


      var subscriptionExrAccess = subscription && subscription.exrAccess;
      var aclExrAccess = acl && acl.exrAccess;
      var exrAccess = subscriptionExrAccess || aclExrAccess;
      var showExr = exrAccess == 'full';

      var styles = require('./AssetPopupSettings.scss');

      return _react2.default.createElement(
        'ul',
        null,
        this.renderMasterSwitch(showExr),
        components.filter(function (c) {
          return !!c.included;
        }).map(function (c) {
          var _classnames4;

          var component = asset.components.find(function (comp) {
            return comp.type == c.type;
          });

          if (!component) return null;

          var averageColorSpanStyles = {
            backgroundColor: component.averageColor
          };

          var classes = (0, _classnames7.default)((_classnames4 = {}, (0, _defineProperty3.default)(_classnames4, styles.AssetPopupSettings__component, true), (0, _defineProperty3.default)(_classnames4, styles['AssetPopupSettings__component-noExr'], !showExr), (0, _defineProperty3.default)(_classnames4, styles['AssetPopupSettings__component--included'], c.selected), _classnames4));

          return _react2.default.createElement(
            'li',
            { className: classes, key: component.type },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement('span', { className: styles['AssetPopupSettings__component-average-color'], style: averageColorSpanStyles }),
              _react2.default.createElement(
                'span',
                { className: styles['AssetPopupSettings__component-name'] },
                '' + component.name
              ),
              _react2.default.createElement(_components.Checkbox, {
                className: styles['AssetPopupSettings__component-include'],
                name: component.type,
                checked: masterToggleClicked ? masterToggleValue : c.selected,
                onChange: _this4.handleComponentSwitched.bind(_this4) })
            ),
            showExr && _react2.default.createElement(
              'span',
              { className: styles['AssetPopupSettings__component-mimeType'] },
              _react2.default.createElement(
                _components.Select,
                {
                  name: c.type,
                  value: c.mimeType,
                  className: styles['AssetPopupSettings__component-mimeTypeSelect'],
                  onChange: _this4.handleComponentMimetypeChanged.bind(_this4) },
                (0, _utils.getComponentMimetypes)(component).map(function (mimeType) {
                  return _react2.default.createElement(
                    'option',
                    {
                      id: mimeType,
                      key: Math.random() + '-' + mimeType,
                      value: mimeType },
                    (0, _utils.getFileTypeFromMimeType)(mimeType).toUpperCase()
                  );
                })
              )
            )
          );
        })
      );
    }
  }, {
    key: 'onTopupClick',
    value: function onTopupClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.TopupDialog, null));
    }
  }, {
    key: 'renderActionButton',
    value: function renderActionButton() {
      var _classnames5;

      var _props13 = this.props,
          assetDownloadRequesting = _props13.assetDownloadRequesting,
          onDownloadClick = _props13.onDownloadClick,
          onAcquireClick = _props13.onAcquireClick,
          asset = _props13.asset,
          subscription = _props13.subscription;
      var auth = this.context.auth;
      var user = this.props.user;

      var styles = require('./AssetPopupSettings.scss');

      var loggedIn = auth.loggedIn;
      var loadingSubscription = user && user.loading;
      var hasSubscription = loggedIn && user && user.subscription && user.subscription.planId;
      var isSubscriptionActive = subscription && subscription.isActive; //hasSubscription && user.subscription.status && user.subscription.status == 'active';

      var lowQuota = user && user.quota && user.quota.currentQuota - (asset.points || 1) < 0;

      var assetAcquired = asset.acl && asset.acl.resolution && asset.acl.resolution > 0;

      var freeAsset = asset.points === 0;

      var actionButtonClassName = (0, _classnames7.default)((_classnames5 = {}, (0, _defineProperty3.default)(_classnames5, styles['AssetPopupSettings__action-button'], true), (0, _defineProperty3.default)(_classnames5, styles['AssetPopupSettings__action-button--busy'], assetDownloadRequesting), _classnames5));

      return freeAsset || loggedIn && assetAcquired ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Button, { primary: true, className: actionButtonClassName, label: 'Download', onClick: onDownloadClick })
      ) : loggedIn && loadingSubscription ? _react2.default.createElement(_components.LoadingIndicator, { className: styles['AssetPopupSettings__action-button-loadingIndicator'] }) : loggedIn && !isSubscriptionActive ? _react2.default.createElement(
        'div',
        { className: styles.AssetPopupSettings__subscribe },
        _react2.default.createElement(_components.Button, {
          primary: true,
          link: true,
          to: '/pricing',
          label: 'Subscribe Now'
        })
      ) : loggedIn && lowQuota ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: styles['AssetPopupSettings__action-subtext'] },
          'Out of points?'
        ),
        _react2.default.createElement(_components.Button, { primary: true, className: actionButtonClassName, label: 'Top-up points', onClick: this.onTopupClick.bind(this) })
      ) : loggedIn ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Button, { primary: true, className: actionButtonClassName, label: 'Download', onClick: onAcquireClick })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Button, { primary: true, link: true, to: { pathname: '/login', query: { returnTo: '/assets/' + asset.id } }, className: actionButtonClassName, label: 'Login to Download' })
      );
    }
  }, {
    key: 'renderBuyMorePoints',
    value: function renderBuyMorePoints() {
      var user = this.props.user;
      var auth = this.context.auth;

      var loggedIn = auth.loggedIn;
      var subscription = user.subscription;


      var styles = require('./AssetPopupSettings.scss');
      var points = user && user.quota && user.quota.currentQuota;

      return loggedIn && subscription ? _react2.default.createElement(
        'div',
        { className: styles['AssetPopupSettings__report-container'] },
        _react2.default.createElement(
          'span',
          null,
          'You have ' + (points || '–') + ' points '
        ),
        _react2.default.createElement(_components.TextButton, {
          small: true,
          className: styles['AssetPopupSettings__report-button'],
          label: 'Get more!',
          onClick: this.onTopupClick.bind(this)
        })
      ) : null;
    }
  }, {
    key: 'renderReportButton',
    value: function renderReportButton() {
      var _this5 = this;

      var styles = require('./AssetPopupSettings.scss');

      return _react2.default.createElement(
        'div',
        { className: styles['AssetPopupSettings__report-container'] },
        _react2.default.createElement(
          'span',
          null,
          'Found a bug? Report this asset '
        ),
        _react2.default.createElement(_components.TextButton, {
          small: true,
          className: styles['AssetPopupSettings__report-button'],
          label: 'here',
          onClick: function onClick() {
            return _this5.context.dialogs.custom(_react2.default.createElement(_components.ReportAssetDialog, { asset: _this5.props.asset.id }));
          }
        })
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var asset = this.props.asset;

      var styles = require('./AssetPopupSettings.scss');

      return _react2.default.createElement(
        'div',
        null,
        this.renderActionButton(),
        this.renderBuyMorePoints(),
        this.renderReportButton()
      );
    }
  }]);
  return AssetPopupSettings;
}(_react2.default.Component), _class.contextTypes = {
  auth: _react2.default.PropTypes.object,
  user: _react2.default.PropTypes.object,
  location: _react2.default.PropTypes.object,
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object,
  doSearch: _react2.default.PropTypes.func
}, _temp);
exports.default = AssetPopupSettings;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetPopupSettings/AssetPopupSettings.jsx
// module id = 2461
// module chunks = 0